<nav class="header-wrap noselect">
  <div class="container">
    <div class="row align-items-center py-3">
      <div *ngIf="!isHome" class="col-auto">
        <img routerLink="/" src="../../assets/car-transparent.png" alt="Kingdom Brothers Auto Logo" class="logo">
      </div>
      <div class="col">&nbsp;</div>

      <div *ngIf="hasAdminPermissions()" class="col-auto dropdown-hover" ngbDropdown>
        <a class="nav-link dropdown-toggle" ngbDropdownToggle id="adminDropdown" role="button">
          <span class="fa fa-solid fa-screwdriver-wrench fa-lg"></span>
        </a>
        <div ngbDropdownMenu aria-labelledby="adminDropdown">
          <a *ngIf="permissions?.includes('APP_MANAGEMENT')" [routerLink]="[userRoute, userModuleRoutes.appManagement]" class="dropdown-item">App Management</a>
          <a *ngIf="permissions?.includes('USER_MANAGEMENT')" [routerLink]="[userRoute, userModuleRoutes.userManagement]" class="dropdown-item">User Management</a>
          <a *ngIf="permissions?.includes('ROLE_MANAGEMENT')" [routerLink]="[userRoute, userModuleRoutes.roleManagement]" class="dropdown-item">Role Management</a>
        </div>
      </div>

      <div class="col-auto dropdown-hover" ngbDropdown>
        <a class="nav-link" ngbDropdownToggle id="userDropdown" role="button">
          <span class="fa fa-user fa-lg"></span>
        </a>
        <div ngbDropdownMenu aria-labelledby="userDropdown">
          <div class="px-3 pb-2" *ngIf="user">Hello {{ user.firstName }}!</div>
          <a *ngIf="user" class="dropdown-item" [routerLink]='[userRoute, user.userId]'>Profile</a>
          <a *ngIf="user && (permissions?.includes('VIEW_GARAGE') || permissions?.includes('VIEW_ALL_GARAGES'))" class="dropdown-item" routerLink="/my-garage">My Garage</a>
          <a *ngIf="user && (permissions?.includes('VIEW_INVOICES') || permissions?.includes('VIEW_ALL_INVOICES'))" class="dropdown-item" [routerLink]='[invoiceRoute]'>Invoices</a>
          <a *ngIf="user && permissions?.includes('EDIT_ALL_INVOICES')" class="dropdown-item" [routerLink]='[invoiceRoute, invoiceModuleRoutes.create]'>Create Quote</a>
          <a *ngIf="user" class="dropdown-item" [routerLink]='[authRoute, authModuleRoutes.logout]'>Logout</a>
          <a *ngIf="!user" class="dropdown-item" [routerLink]='[authRoute, authModuleRoutes.login]'>Login</a>
          <a *ngIf="!user" class="dropdown-item" [routerLink]='[authRoute, authModuleRoutes.register]'>Register</a>
        </div>
      </div>
    </div>
  </div>
</nav>




